var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.inline,
    _vm.isFullWidth && _vm.$style.fullWidthWrapper
  ],on:{"click":function($event){_vm.isDisabled || _vm.$emit('click')}}},[_c('div',{class:[
      'isButton',
      _vm.$style.wrapper,
      _vm.$style[("variant-" + _vm.variant)],
      _vm.$style[("font-weight-" + _vm.fontWeight)],
      _vm.$style[("font-size-" + _vm.fontSize)],
      _vm.$style[("align-" + _vm.alignment)],
      _vm.$style[("size-" + _vm.size)],
      _vm.textColor && _vm.$style[("text-color-" + _vm.textColor)],
      _vm.isRounded && _vm.$style.rounded,
      _vm.leftRounded && _vm.$style.leftRounded,
      _vm.rightRounded && _vm.$style.rightRounded,
      _vm.isDisabled && _vm.$style.disabled,
      _vm.className
    ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }